import React,{ Component } from "react";
import { connect } from "react-redux";
import ImageForm from "../ImageForm/ImageForm";
import { createImage } from "../../../actions/actionImage";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/workspaces",isActive: false},
    {name: "CreateImages",path:"/createworkspace",isActive: true},
];

class CreateImage extends Component{

    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>   
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Workspace</strong>
                                </CardHeader>
                                <ImageForm
                                    createImage={this.props.createImage}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateImage.propTypes = {
    createImage: Proptypes.func.isRequired
};

export default connect(state => ({
    images: state.images.images || []
}), 
dispatch => ({
    createImage: (data) => dispatch(createImage(data))
}))(CreateImage);